import {
  FormControl,
  TextField,
  TextFieldProps,
  useTheme
} from "@mui/material";
import React from "react";
// import { useTranslation } from "react-i18next";
import { InputBaseComponentInterface } from "./types";

const InputCst: React.FC<TextFieldProps & InputBaseComponentInterface> = (
  props
) => {
  const theme = useTheme();
  // const { t } = useTranslation(["input"]);

  const {
    id,
    label,
    type,
    value,
    onChange,
    customWidth,
    error = false,
    errorMessage = "",
    disabled = false,
    sx,
    maxValue,
    max,
    endAdornment
  } = props;

  return (
    <FormControl
      fullWidth
      variant="standard"
      sx={ {
        // backgroundColor: "transparent",
        "& .MuiFormLabel-root": {
          "&[data-shrink='true']": {
            maxWidth: "calc(133% - 40px)"
          },
          color: theme.customColors.textPrimary,
          maxWidth: "calc(100% - 40px)"
        },
        "& .MuiInputBase-root fieldset": {
          borderColor: theme.customColors.border
        },
        "& .MuiInputBase-root.Mui-focused fieldset": {

          borderColor: theme.customColors.borderPrimaryCta
        },
        "& .MuiInputLabel-root.Mui-focused.MuiInputLabel-shrink": {
          color: theme.customColors.borderPrimaryCta
        },
        alignItems: "center",
        display: "flex",
        minWidth: "200px",
        width: customWidth ? customWidth : "auto",
        ...sx
      } }
    >
      <TextField
        { ...props }
        fullWidth
        sx={ {
          "& .MuiOutlinedInput-root": {
            borderRadius: "0.5rem",
            ...(props.multiline ? {} : {
              height: "2.27rem",
              "& .MuiOutlinedInput-input": {
                height: "100%",
                boxSizing: "border-box",
                paddingTop: 0,
                paddingBottom: 0
              }
            }),
            "& fieldset": {
              borderColor: theme.customColors.border
            }
          },
          "& .MuiInputLabel-root": {
            fontSize: "0.875rem"
          },
          ...(props.multiline ? {} : {
            "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
              transform: "translate(14px, 0.5rem) scale(1)"
            }
          }),
          "& .MuiFormLabel-root": {
            color: theme.customColors.textPrimary
          },
          "& .MuiInputBase-root.Mui-focused fieldset": {
            color: theme.customColors.borderPrimaryCta,
            borderColor: theme.customColors.borderPrimaryCta
          },
          "& .MuiInputLabel-root.Mui-focused.MuiInputLabel-shrink": {
            color: theme.customColors.borderPrimaryCta
          },
          "& .MuiSvgIcon-root": {
            color: theme.customColors.textPrimary
          }
        } }
        size={ "medium" }
        error={ error }
        helperText={
          <span
            style={ {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: 2
            } }
          >
            { error ? errorMessage : "" }
          </span>
        }
        id={ id }
        label={ label }
        InputProps={ {
          endAdornment: endAdornment
        } }
        value={ value }
        onChange={ (e)=>{
          if(type === "number" && isNaN(Number(e.target.value))) return; 
          onChange && onChange(e);
        } 
        }
        disabled={ disabled }
        inputProps={ {
          max: max,
          maxLength: maxValue,
          min: 0
        } }
      />
    </FormControl>
  );
};

export default InputCst;
